module.exports = __webpack_public_path__ + "img/w3_package_light.1bae4967.png";